<script setup lang="ts">
import { computed } from 'vue';
import type { CmsIconName } from '@pkg/cms-icons/src/types';
import { cmsIcons } from '@pkg/cms-icons/src/icons';
import { logger } from '@pkg/logger';

const props = defineProps<{
  name: string;
  as?: string;
}>();

const iconName = computed(() => {
  if (!(props.name in cmsIcons)) {
    logger.warn(`${props.name} is not a valid cms icon name`);
    return `cms:${props.name}`;
  }
  const icon = cmsIcons[props.name as CmsIconName];
  return `cms:${icon.iconName}`;
});

</script>

<template>
  <component :is="props.as || 'div'" class="cms-icon">
    <NuxtIcon :name="iconName" />
  </component>
</template>

<style scoped>
.cms-icon {
  width: 1em;
  height: 1em;
}

.cms-icon :deep(svg) {
  width: 1em;
  height: 1em;
  margin: 0;
}
</style>
